import axios from "axios";

const getBaseUrl = () => {
  if (typeof window !== 'undefined' && window.location.hostname === 'ambassador.eamico.com') {
    return '';
  }
  return process.env.REACT_APP_BACKEND_URL || '';
};

const api = axios.create({
  baseURL: `${getBaseUrl()}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" }
});

// Auto-refresh on 401
api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalRequest = err.config;
    if (err.response?.status === 401 && !originalRequest._retry && !originalRequest.url?.includes('/auth/')) {
      originalRequest._retry = true;
      try {
        await axios.post(`${getBaseUrl()}/api/auth/refresh`, {}, { withCredentials: true });
        return api(originalRequest);
      } catch {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
